import axios from 'axios';

// Récupérer le profil de l'utilisateur connecté
export const getProfile = async (token) => {
    const response = await axios.get('/api/users/profile', {
        headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
};

// Récupérer tous les utilisateurs (admin)
export const getAllUsers = async (token) => {
    const response = await axios.get('/api/users', {
        headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
};